var nunjucks = require("nunjucks/browser/nunjucks-slim");
var env;
if (!nunjucks.currentEnv){
	env = nunjucks.currentEnv = new nunjucks.Environment([], undefined);
} else {
	env = nunjucks.currentEnv;
}
var configure = require("../../../../core/js/filters/nunjucks-config.js")(env);
var dependencies = nunjucks.webpackDependencies || (nunjucks.webpackDependencies = {});




var shim = require("/jh/workspace/MonoWeb-Build-Release/monoweb/node_modules/nunjucks-loader/runtime-shim");


(function() {(nunjucks.nunjucksPrecompiled = nunjucks.nunjucksPrecompiled || {})["account/templates/partials/payment-form/credit-card-associated-address-select.j2"] = (function() {
function root(env, context, frame, runtime, cb) {
var lineno = null;
var colno = null;
var output = "";
try {
var parentTemplate = null;
output += "\n<div class=\"c-form__field is-required\">\n\n    <label for=\"billing-address-payments\" class=\"c-form__label\" data-qa-credit-card-billing-address-text>\n\n        ";
output += runtime.suppressValue((lineno = 5, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_orderDetails-billingAddress",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n    </label>\n\n    <select class=\"c-form__select js-account-payment-form-item\" id=\"billing-address-payments\" required aria-required=\"true\" name=\"creditCardDetail.addressId\" data-qa-credit-card-billing-address aria-describedby=\"billing-address-payments_error\">\n\n        <option value=\"\">\n\n            ";
output += runtime.suppressValue((lineno = 13, colno = 13, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_accountSettings-selectAddress",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n        </option>\n\n        ";
frame = frame.push();
var t_3 = (lineno = 17, colno = 35, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["userAddresses"]));
if(t_3) {var t_2 = t_3.length;
for(var t_1=0; t_1 < t_3.length; t_1++) {
var t_4 = t_3[t_1];
frame.set("address", t_4);
frame.set("loop.index", t_1 + 1);
frame.set("loop.index0", t_1);
frame.set("loop.revindex", t_2 - t_1);
frame.set("loop.revindex0", t_2 - t_1 - 1);
frame.set("loop.first", t_1 === 0);
frame.set("loop.last", t_1 === t_2 - 1);
frame.set("loop.length", t_2);
output += "\n\n            ";
output += "\n            ";
if(runtime.memberLookup((runtime.memberLookup(((lineno = 20, colno = 27, runtime.callWrap(runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "Address")),"get"), "Address[\"get\"]", context, ["temp"]))),"creditCardDetail")),"addressId") == runtime.memberLookup((t_4),"id")) {
output += "\n\n                <option value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += "\" selected >\n\n                    ";
output += runtime.suppressValue((runtime.memberLookup((t_4),"nickName")?runtime.memberLookup((t_4),"nickName"):runtime.memberLookup((runtime.memberLookup((t_4),"address")),"address1")), env.opts.autoescape);
output += "\n\n                </option>\n\n            ";
;
}
else {
output += "\n\n                <option value=\"";
output += runtime.suppressValue(runtime.memberLookup((t_4),"id"), env.opts.autoescape);
output += "\" >\n\n                    ";
output += runtime.suppressValue((runtime.memberLookup((t_4),"nickName")?runtime.memberLookup((t_4),"nickName"):runtime.memberLookup((runtime.memberLookup((t_4),"address")),"address1")), env.opts.autoescape);
output += "\n\n                </option>\n\n            ";
;
}
output += "\n\n        ";
;
}
}
frame = frame.pop();
output += "\n\n        ";
output += "\n        <option value=\"new-address\">\n\n            ";
output += runtime.suppressValue((lineno = 43, colno = 13, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_addressAndPayments-addNewAddress",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n        </option>\n\n    </select>\n\n    <span class=\"c-form-message\" data-qa-error-field=\"account_validations-missingAddress\" id=\"billing-address-payments_error\">\n\n        ";
output += runtime.suppressValue((lineno = 51, colno = 9, runtime.callWrap(runtime.contextOrFrameLookup(context, frame, "t"), "t", context, ["account_validations-missingAddress",runtime.makeKeywordArgs({"state": runtime.memberLookup((runtime.contextOrFrameLookup(context, frame, "state")),"core")})])), env.opts.autoescape);
output += "\n\n    </span>\n\n</div>\n";
if(parentTemplate) {
parentTemplate.rootRenderFunc(env, context, frame, runtime, cb);
} else {
cb(null, output);
}
;
} catch (e) {
  cb(runtime.handleError(e, lineno, colno));
}
}
return {
root: root
};

})();
})();



module.exports = shim(nunjucks, env, nunjucks.nunjucksPrecompiled["account/templates/partials/payment-form/credit-card-associated-address-select.j2"] , dependencies)